<template>
  <div class="Stepped" :class="[status, cssIndex]">
    <div class="line above" :class="{ first }" />
    <div class="content">
      <div class="visual-status">
        <div v-if="isLoading" class="status">
          <Spinner size="small" theme="positive" />
        </div>
        <div v-else-if="!isDone" class="status">{{ index }}</div>
        <div v-else class="status">
          <BaseIcon name="check-mono" />
        </div>
      </div>
      <p class="status-description"><slot /></p>
    </div>
    <div class="line below" :class="{ last }" />
  </div>
</template>

<script>
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'
import Spinner from '@/aasgard/components/feedback/Spinner.vue'

export default {
  name: 'Stepped',
  components: { Spinner, BaseIcon },
  props: {
    first: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    last: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'not-started',
      validator(value) {
        return (
          ['done', 'in-progress', 'loading', 'not-started'].includes(value) ||
          value === 'not-started'
        )
      },
    },
  },
  computed: {
    cssIndex() {
      return {
        first: this.first,
        last: this.last,
      }
    },
    isDone() {
      return this.status === 'done'
    },
    isLoading() {
      return this.status === 'loading'
    },
  },
}
</script>

<style lang="scss">
.Stepped {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &,
  * {
    box-sizing: border-box;
  }

  .line {
    width: 2px;
    height: 8px;
    content: '';
    margin-left: 11px;

    &.first,
    &.last {
      background-color: transparent !important;
    }
  }

  .content {
    display: flex;
    align-items: center;

    .visual-status {
      width: 24px;
      box-sizing: border-box;
      margin-right: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .status {
        @include body-2;
        margin: 0;
        width: 24px;
        height: 24px;
        box-sizing: border-box;
        border-radius: 50%;
        border-style: solid;
        border-width: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .status-description {
      @include body-1;
      margin: 0;
    }
  }
}
.Stepped.not-started {
  .line {
    background-color: $color-black-medium;
  }

  .content {
    .visual-status {
      .status {
        border-color: $color-black-medium;
        color: $color-black-medium;
      }
    }

    .status-description {
      color: $color-black-medium;
    }
  }
}
.Stepped.in-progress {
  line.above {
    background-color: $color-feedback-positive;
  }
  line.below {
    background-color: $color-black-medium;
  }

  .content {
    .visual-status {
      .status {
        border-color: $color-feedback-positive;
        color: $color-feedback-positive;
      }
    }

    .status-description {
      color: $color-feedback-positive;
    }
  }
}

.Stepped.loading {
  line.above {
    background-color: $color-feedback-positive;
  }
  line.below {
    background-color: $color-black-medium;
  }

  .content {
    .visual-status {
      .status {
        background-color: transparent;
        border: none;
      }
    }

    .status-description {
      color: $color-feedback-positive;
    }
  }
}

.Stepped.done {
  .line {
    background-color: $color-feedback-positive;
  }

  .content {
    .visual-status {
      .status {
        background-color: $color-feedback-positive;
        border-color: $color-feedback-positive;
        color: $color-feedback-positive;
        position: relative;

        svg.BaseIcon {
          position: absolute;
          left: -2px;
          :not(svg) {
            stroke: #fff !important;
            stroke-opacity: 1;
          }
        }
      }
    }

    .status-description {
      color: $color-feedback-positive;
    }
  }
}
</style>
